// 为了处理部分接口接受直辖市的citycode而无法识别其对应的省code
// const provinceLevelCity = [110000, 120000, 310000, 500000]
const Province2City = new Map([
  [110000, 110100],
  [120000, 120100],
  [310000, 310100],
  [500000, 500100]
])
const City2Province = new Map([
  [110100, 110000],
  [120100, 120000],
  [310100, 310000],
  [500100, 500000]
])
/**
 * 将部分 城市编码 [110000, 120000, 310000, 500000] 更正为市级编码
 * @param {string | number} citycode
 * @returns {Number}
 */
export const changePrivinceCodeToCityCode = citycode => {
  // citycode = citycode ? Number(citycode) : 320100
  // if (provinceLevelCity.includes(citycode)) {
  //   citycode += 100
  // }
  const tmp = Province2City.get(+citycode)
  return tmp || +citycode
}
/**
 * 将部分城市编码匹配为获取城市列表内对应的城市编码
 * @param {string | number} cityCode
 * @returns {Number}
 */
export const changeCityCode2ProvinceCode = cityCode => {
  const tmp = City2Province.get(+cityCode)
  return tmp || +cityCode
}
